module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-button"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Button")]), _vm._v(" "), _c('div', {
    staticClass: "page-button-group"
  }, [_c('mt-button', {
    attrs: {
      "size": "large"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "danger"
    }
  }, [_vm._v("danger")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-button-group"
  }, [_c('mt-button', [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("danger")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-button-group"
  }, [_c('mt-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    }
  }, [_vm._v("danger")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-button-group"
  }, [_c('mt-button', {
    attrs: {
      "disabled": "",
      "size": "large"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "disabled": "",
      "size": "large",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "disabled": "",
      "size": "large",
      "type": "danger"
    }
  }, [_vm._v("danger")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-button-group"
  }, [_c('mt-button', {
    attrs: {
      "plain": "",
      "size": "large"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "plain": "",
      "size": "large",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "plain": "",
      "size": "large",
      "type": "danger"
    }
  }, [_vm._v("danger")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-button-group"
  }, [_c('mt-button', [_c('img', {
    attrs: {
      "src": require("../assets/100x100.png"),
      "height": "20",
      "width": "20"
    },
    slot: "icon"
  }), _vm._v("\n      带自定义图标\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b508220"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/button.vue
// module id = 304
// module chunks = 0